var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProfileIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 15,
    viewBox: "0 0 16 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Profile"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M7.99991 7.02667C8.78657 7.02667 9.42657 6.38667 9.42657 5.6C9.42657 4.81333 8.78657 4.16667 7.99991 4.16667C7.21324 4.16667 6.57324 4.80667 6.57324 5.59333C6.57324 6.38 7.21324 7.02667 7.99991 7.02667Z",
    stroke: "#666666",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M10.8596 10.8333C10.8596 9.54 9.57298 8.5 7.99964 8.5C6.42631 8.5 5.13965 9.54 5.13965 10.8333",
    stroke: "#666666",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M7.99967 14.1667C4.33301 14.1667 1.33301 11.1667 1.33301 7.5C1.33301 3.83333 4.33301 0.833334 7.99967 0.833334C11.6663 0.833334 14.6663 3.83333 14.6663 7.5C14.6663 11.1667 11.6663 14.1667 7.99967 14.1667Z",
    stroke: "#666666",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfileIcon);
export default __webpack_public_path__ + "static/media/profile-icon.c68f75a4692bd5f856ab463840770823.svg";
export { ForwardRef as ReactComponent };